import { render, staticRenderFns } from "./ElementDetail.vue?vue&type=template&id=6bca2940&scoped=true&"
import script from "./ElementDetail.vue?vue&type=script&lang=js&"
export * from "./ElementDetail.vue?vue&type=script&lang=js&"
import style0 from "./ElementDetail.vue?vue&type=style&index=0&id=6bca2940&prod&scoped=true&lang=scss&"
import style1 from "./ElementDetail.vue?vue&type=style&index=1&id=6bca2940&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bca2940",
  null
  
)

export default component.exports